module.exports = __webpack_public_path__ + "img/results.b2420241.png";